import determineBondMaturityDate from "../../components/moneyBuilder/investments/objects/determine_bond_maturity_date"

export const determineBondMaturityDateArr = (investmentTrans, investmentMaster, 
    maturityDateArr, startGameDate, currentGameDate) => {

    let maxIndx = maturityDateArr.length - 1;
    for (let i=maxIndx; i>=0; i--){
        if (maturityDateArr[i].maturityDate < currentGameDate){
            maturityDateArr.splice(i,1);
        }
    }
    for (let i=0; i<investmentTrans.length; i++){
        const shortName = investmentTrans[i].investShortName;
        const maturityDateValue = maturityDateArr.find(elem => elem.investShortName === shortName);
        if (!maturityDateValue){
            const investMaster = investmentMaster.find(elem => elem.investShortName === shortName);
            if (investMaster && investMaster.bondInfo){
                const maturityDateInfo = 
                    determineBondMaturityDate(investMaster.bondInfo, startGameDate);
                const maturityDateObj = 
                    {investShortName: shortName, maturityDate: maturityDateInfo.maturityDate};
                maturityDateArr.push(maturityDateObj)
            }
        }
        
    }    
    return maturityDateArr;
}

export default determineBondMaturityDateArr;
